import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import UserPool from "../UserPool";
import { useAuthContext } from "../contexts/AuthContext";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const navigate = useNavigate();
  const { userEmail, logout } = useAuthContext();

  useEffect(() => {
    // Check if the user is authenticated
    if (!userEmail) {
      // Redirect to the login page if not authenticated
      console.log("Redirecting to login - User not authenticated");
      navigate("/login");
    }
  }, [userEmail, navigate]);

  const onChangePassword = async () => {
    const user = new CognitoUser({ Username: userEmail, Pool: UserPool });
    const authDetails = new AuthenticationDetails({ Username: userEmail, Password: oldPassword });

    return new Promise((resolve, reject) => {
      user.authenticateUser(authDetails, {
        onSuccess: (session) => {
          user.changePassword(oldPassword, newPassword, (err, result) => {
            if (err) {
              console.error("Change password failed:", err);
              reject(err);
            } else {
              console.log("Password change successful:", result);
              resolve(result);
            }
          });
        },
        onFailure: (err) => {
          console.error("Authentication failed:", err);
          reject(err);
        },
      });
    });
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    try {
      await onChangePassword();

      // Logout after successful password change
      logout();

      // Optionally, you can redirect the user to a success page or handle it as needed
      console.log("Password changed successfully");
    } catch (error) {
      // Handle password change failure
      console.error("Password change error:", error);
    }
  };

  return (
    <div>
      <form onSubmit={onSubmit}>
        <label htmlFor="oldPassword">Old Password</label>
        <input
          type="password"
          value={oldPassword}
          onChange={(event) => setOldPassword(event.target.value)}
        ></input>
        <label htmlFor="newPassword">New Password</label>
        <input
          type="password"
          value={newPassword}
          onChange={(event) => setNewPassword(event.target.value)}
        ></input>

        <button type="submit">Change Password</button>
      </form>
    </div>
  );
};

export default ChangePassword;
